export default "__VITE_ASSET__DkVrd0GV__"